export default __webpack_public_path__ + "static/media/pink-delete.5fb136db.svg";